export enum NotificationStatus {
    ON_TIME = 'flightChangesCases.notificationStatus.onTime',
    AT_RISK = 'flightChangesCases.notificationStatus.atRisk',
    LATE = 'flightChangesCases.notificationStatus.late'
}

export enum CaseStatus {
    PENDING = 'flightChangesCases.caseStatus.pending',
    ON_HOLD = 'flightChangesCases.caseStatus.onHold',
    IN_ANALYSIS = 'flightChangesCases.caseStatus.inAnalysis',
    NOT_APPLICABLE = 'flightChangesCases.caseStatus.notApplicable',
    SENDING_ERROR = 'flightChangesCases.caseStatus.sendingError',
    NOTIFIED = 'flightChangesCases.caseStatus.notified',
    TO_NOTIFY = 'flightChangesCases.caseStatus.toNotify',
}

export const READ_ONLY_CASE_STATUSES: CaseStatus[] = [
    CaseStatus.NOTIFIED,
    CaseStatus.NOT_APPLICABLE,
    CaseStatus.SENDING_ERROR,
];

export const isCaseReadOnlyStatus = (status: CaseStatus | string | undefined): boolean =>
    status != null && isValidCaseStatus(status) && READ_ONLY_CASE_STATUSES.includes(status as CaseStatus);

export const isValidCaseStatus = (status: string): status is CaseStatus => {
    return Object.values(CaseStatus).includes(status as CaseStatus);
};

export const isValidNotificationStatus = (status: string): status is NotificationStatus => {
    return Object.values(NotificationStatus).includes(status as NotificationStatus);
};

